//=====================================================
// 予約変更ボタン
//=====================================================
interface IFProps {
    enable : boolean,
    onClick? : React.MouseEventHandler<HTMLButtonElement>
}

export function BtnReservationChange(props: IFProps){

    return (
        <>
            { props.enable ?
                <button onClick={props.onClick} className="btn btn-reserve-change">変更</button>
                :
                <button className="btn btn-reserve-change is-inactive">変更不可</button>
            }
        </>
    );

}